module.exports = __webpack_public_path__ + "static/img/img_t0.30ec77ac.png";